import { render, staticRenderFns } from "./OccupantQuestions.vue?vue&type=template&id=c8529f38&"
import script from "./OccupantQuestions.vue?vue&type=script&lang=js&"
export * from "./OccupantQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports